// extracted by mini-css-extract-plugin
export default {"dataRow":"DataTable_dataRow__LiMqW"};